import { Box, Chip, Stack, type SxProps, type Theme, Typography } from '@mui/material';
import type React from 'react';

export const CHIP_COLORS = {
    // CATEGORY COLORS
    cycle: { background: '#DFCBF2', color: '#400B73' },
    positioning: { background: '#B8F2C7', color: '#084D19' },
    catalogZone: { background: '#B8F2ED', color: '#084D47' },
    crop: { background: '#FFE6B2', color: '#593F09' },
    // CAMPAIGN COLOTS
    fieldview: { background: '#F2F2B6', color: '#404006' },
    campaign: { background: '#FFBECE', color: '#443247' },
    // CROP COLORS
    corn: { background: '#F2F2B6', color: '#404006' },
    soy: { background: '#D3FFD7', color: '#053709' },
    fallow: { background: '#CDF1FF', color: '#10384F' },
    wheat: { background: '#FFE6B2', color: '#593F09' },
    hybrid: { background: '#F2F2B6', color: '#404006' },
    density: { background: '#F2F2B6', color: '#404006' },
    cropProtection: { background: '#B8F2C7', color: '#084D19' },
    // STATUS COLORS
    success: { background: '#D3FFD7', color: '#053709' },
    danger: { background: '#FFC18D', color: '#652D01' },
    // USER TYPES COLORS
    consultant: { background: '#B8F2ED', color: '#084D47' },
    rv: { background: '#C2E0FF', color: '#10384F' },
    advisor: { background: '#DFCBF2', color: '#400B73' },
    // OTHER COLORS
    nSmart: { background: '#FFD6D6', color: '#730B0B' },
    primary: { background: '#10384F', color: '#FFFFFF' },
    barley: { background: '#EAD5BB', color: '#593F09' },
    // GROWERS COLORS
    premiumGrower: { background: '#C2E0FF', color: '#0B3F73' },
    commonGrower: { background: '#DFCBF2', color: '#400B73' },
    gray: { background: '#F5F5F5', color: '#474747' },
};

const ChipLabel = ({
    label,
    type,
    background,
    color,
    icon,
    size = 'md',
    text,
    sx,
}: {
    label: string;
    icon?: React.ReactNode;
    size?: 'xs' | 'sm' | 'md';
    text?: string;
    sx?: SxProps<Theme>;
} & (
    | {
          type: 'custom';
          background: string;
          color: string;
      }
    | {
          type: keyof typeof CHIP_COLORS;
          background?: never;
          color?: never;
      }
)) => {
    const colors = {
        ...CHIP_COLORS,
        custom: {
            background,
            color,
        },
    };
    console.log(type, colors[type]);
    return (
        <Chip
            key={label}
            label={
                <Box display='flex' alignItems='center' gap={0.5}>
                    {icon && icon}
                    <Stack direction='row' spacing={0.5}>
                        <Typography variant='caption' fontWeight={700}>
                            {label}
                        </Typography>
                        {text && <Typography variant='caption'>{text}</Typography>}
                    </Stack>
                </Box>
            }
            size={size === 'xs' ? undefined : 'small'}
            sx={{
                '& .MuiChip-label': (t: Theme) => ({
                    ...t.typography.caption,
                    fontWeight: 700,
                    ...(size === 'xs' && {
                        height: '18px',
                        padding: '0 6px',
                        fontSize: '0.65rem',
                        lineHeight: '18px',
                    }),
                }),
                width: 'fit-content',
                ...colors[type],
                ...(size === 'sm' && {
                    height: 'unset',
                    borderRadius: 20,
                }),
                ...(size === 'xs' && {
                    height: '18px !important',
                    minHeight: '18px',
                    borderRadius: 20,
                }),
                '& svg': {
                    fill: colors[type]?.color,
                    '& path': {
                        fill: colors[type]?.color,
                    },
                },
                ...sx,
            }}
        />
    );
};

export default ChipLabel;
